import { CagingEntryLoader } from '@p/utilities/actions/caging-entry.loader';
import { WhiteMailLoader } from '@p/utilities/actions/whitemail-loader';

import { RouteGuard } from 'hoc/route-guard';
import { Route } from 'types/routes';
import { lazyNamed } from 'utilities/lazy-named';
import { s } from 'utilities/strings';

const PDFPackageManagementPage = lazyNamed(() => import('pages/utilities/pdf-package'), 'PDFPackageManagementPage');
const UtilitiesPage = lazyNamed(() => import('pages/utilities'), 'UtilitiesPage');
const DailiesManagementPage = lazyNamed(() => import('pages/utilities/dailies'), 'DailiesManagementPage');
const LRIManagementPage = lazyNamed(() => import('pages/utilities/lri'), 'LRIManagementPage');
const ExceptionPage = lazyNamed(() => import('pages/utilities/exceptions'), 'ExceptionPage');

export const utilityRoutes: Route = {
  children: [
    {
      element: <UtilitiesPage />,
      index: true,
    },
    {
      children: [
        {
          element: <DailiesManagementPage />,
          index: true,
          loader: CagingEntryLoader,
        },
      ],
      element: <RouteGuard role={['admin']} />,
      icon: ['fas', 'envelopes-bulk'],
      includeInMenu: true,
      path: 'Root.children.Utilities.children.Caging',
      roles: ['admin'],
      title: 'Caging Entry',
    },
    {
      children: [
        {
          element: <PDFPackageManagementPage />,
          index: true,
        },
      ],
      element: <RouteGuard role={['devops']} />,
      icon: ['fas', 'file-pdf'],
      includeInMenu: true,
      path: 'Root.children.Utilities.children.PDF',
      roles: ['devops'],
      title: s('Site.Pages.Utilities.PDF.PDF'),
    },
    {
      children: [
        {
          element: <LRIManagementPage />,
          index: true,
        },
      ],
      element: <RouteGuard role={['devops']} />,
      icon: ['fas', 'rectangle-list'],
      includeInMenu: true,
      path: 'Root.children.Utilities.children.LRI',
      roles: ['devops'],
      title: s('Site.Pages.Utilities.LRI.LRI'),
    },
    {
      children: [
        {
          element: <DailiesManagementPage />,
          index: true,
          loader: WhiteMailLoader,
        },
      ],
      element: <RouteGuard role={['devops']} />,
      icon: ['fas', 'envelope'],
      includeInMenu: true,
      path: 'Root.children.Utilities.children.Whitemail',
      roles: ['devops'],
      title: s('Site.Pages.Utilities.Whitemail.Whitemail'),
    },
    {
      children: [
        {
          element: <ExceptionPage />,
          index: true,
        },
      ],
      element: <RouteGuard role={['devops']} />,
      icon: ['fas', 'circle-exclamation'],
      includeInMenu: true,
      path: 'Root.children.Utilities.children.Exceptions',
      roles: ['devops'],
      title: s('Site.Pages.Utilities.Exceptions.title'),
    },
  ],
  element: <RouteGuard role={['devops']} />,
  icon: ['fas', 'screwdriver-wrench'],
  includeInMenu: true,
  path: 'Root.children.Utilities.path',
  roles: ['devops'],
  title: s('Site.Utilities'),
};
